<template>
  <!--
    The view for the UserDependentTextOverview-component
  -->
  <div class="userDependentTextOverview">
    <UserDependentTextList
      ref="userDependentTextList"
      :theme-id="themeId"
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :theme-id="themeId"
      :is-theme-elements="true"
      @reload="reloadLayoutElementList"
    />
  </div>
</template>

<script>
export default {
  name: "UserDependentTextOverview",
  components: {
    UserDependentTextList: () => import('@/components/VideoPostprocessing/Theme/UserDependentTextList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
  props: {
    themeId: {
      type: String,
      required: true
    }
  },
  metaInfo () {
    return {
      title: this.$t('videoPostProcessing.title')
    }
  },
  methods: {
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadLayoutElementList () {
      this.$refs.userDependentTextList.closeAndReloadData();
    },
  }
}
</script>
